import { handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  biShiftsByEmployeeSuccess,
  biShiftsByMobilePatrolSuccess,
  biShiftsBySiteSuccess,
  biShiftsDetailedSuccess,
  setLoadingState,
} from './actions';

export default handleActions(
  {
    [biShiftsBySiteSuccess](state, { payload }) {
      return {
        ...state,
        bySite: payload,
      };
    },
    [biShiftsByEmployeeSuccess](state, { payload }) {
      return {
        ...state,
        byEmployee: payload,
      };
    },
    [biShiftsByMobilePatrolSuccess](state, { payload }) {
      return {
        ...state,
        byMobilePatrol: payload,
      };
    },
    [biShiftsDetailedSuccess](state, { payload }) {
      return {
        ...state,
        details: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
